/* >>> RCF-titleswap v1.0 >>> */
/* RichCommerce Flow - variant title swap. base=publisher. auto-generated, do not edit. */
﻿/**
 * variant-gallery-swap.js v0.9.0 (publisher)
 * - high variant(250+) 환경에서 빈 variant id fallback 지원
 * - option 조합 맵(v-option-variant-map) 기반 보정
 * - [v0.9.0] variant-title-data 기반 변형별 제목 교체
 *   ★ 절대원칙: variant-title-data 없으면 완전 무동작 → 기존 상품/갤러리/About 무영향
 */
(function () {
  'use strict';

  if (window.__vgsInited) return;
  window.__vgsInited = true;

  var sectionId = null;
  var currentVarId = null;
  var origBodyHtml = null;

  function getSectionId() {
    if (sectionId) return sectionId;
    var ul = document.querySelector('[id^="Slider-Gallery-"]');
    sectionId = ul ? ul.id.replace('Slider-Gallery-', '') : null;
    return sectionId;
  }

  function normalizeVariantId(v) {
    if (v === undefined || v === null) return '';
    v = String(v).trim();
    if (!v || v === 'undefined' || v === 'null') return '';
    return v;
  }

  function normalizeOptionText(v) {
    if (v === undefined || v === null) return '';
    var s = String(v).replace(/\u00A0/g, ' ').trim();
    while (s.length >= 2 && s.charAt(0) === '~' && s.charAt(s.length - 1) === '~') {
      s = s.substring(1, s.length - 1).trim();
    }
    s = s.replace(/\s+/g, ' ').trim();
    return s;
  }

  function normalizePid(v) {
    if (v === undefined || v === null) return '';
    return String(v).toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function getJsonById(id) {
    var nodes = document.querySelectorAll('script#' + id + '[type="application/json"], script#' + id);
    for (var i = nodes.length - 1; i >= 0; i--) {
      var txt = nodes[i].textContent || '';
      if (!txt.trim()) continue;
      try { return JSON.parse(txt); } catch (e) {}
    }
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent || ''); } catch (e2) { return null; }
  }

  function getGalleryData() {
    return getJsonById('variant-gallery-data');
  }

  function getAboutData() {
    return getJsonById('about-details-data');
  }

  // [title-swap] 변형별 제목 데이터 (없으면 null → updateTitle 즉시 무동작 = 기존 무영향)
  function getTitleData() {
    return getJsonById('variant-title-data');
  }

  function getOptionVariantMap() {
    return getJsonById('v-option-variant-map');
  }

  function getSelectedOptions() {
    var sels = [];
    var vs = document.querySelector('variant-selects, variant-radios');
    if (!vs) return sels;
    vs.querySelectorAll('.product-form__input').forEach(function (box) {
      var r = box.querySelector('input[type=radio]:checked');
      if (r) { sels.push(r.value); return; }
      var sl = box.querySelector('select');
      if (sl && sl.value) sels.push(sl.value);
    });
    return sels;
  }

  function lookupByCurrentOptions() {
    var map = getOptionVariantMap();
    if (!map) return '';
    var sels = getSelectedOptions();
    if (!sels.length) return '';

    var keyRaw = sels.join('|');
    if (map[keyRaw]) return String(map[keyRaw]);

    var keyNorm = sels.map(normalizeOptionText).join('|');
    if (map[keyNorm]) return String(map[keyNorm]);
    var keyNormLower = keyNorm.toLowerCase();
    if (map[keyNormLower]) return String(map[keyNormLower]);

    return '';
  }

  function updateAboutSection(variantId) {
    var aboutData = getAboutData();
    if (!aboutData) return;

    var descEl = (function(){ var w=document.getElementById('v-about-wrap'); if(w) return w.closest('.rte, .product__description')||w.parentElement||w; return document.querySelector('.product__description'); })();
    if (!descEl) return;

    if (origBodyHtml === null) origBodyHtml = descEl.innerHTML;

    var html = aboutData[String(variantId)];
    if (html === undefined || html === null) return;

    descEl.innerHTML = (html === '') ? origBodyHtml : (html + origBodyHtml);
  }

  // [title-swap] 변형 선택 시 <h1>/<h2> 제목 교체.
  //   절대원칙: ① 데이터 없으면 무동작 ② 요소 없으면 무동작 ③ 모든 에러 흡수(기존 갤러리/About 절대 무영향)
  var origTitle = null;
  function updateTitle(variantId) {
    try {
      var titleData = getTitleData();
      if (!titleData) return;                       // variant-title-data 없음(기존 상품/빌더 전) → 무동작
      var els = document.querySelectorAll('.product__title h1, .product__title h2');
      if (!els.length) return;                      // 제목 요소 없음 → 무동작
      if (origTitle === null) origTitle = els[0].textContent;  // 최초 부모 제목 백업(복원용)
      var t = titleData[String(variantId)];
      var newText = (t === undefined || t === null || t === '') ? origTitle : t;
      for (var i = 0; i < els.length; i++) els[i].textContent = newText;
    } catch (e) { /* 제목 교체 실패해도 기존 기능에 절대 영향 없음 */ }
  }

  function urlToPid(url) {
    if (!url) return '';
    url = url.split('?')[0];
    var m;
    m = url.match(/\/I\/([A-Za-z0-9+_\-]{10,32})\./); if (m) return normalizePid(m[1]);
    m = url.match(/\/([A-Za-z0-9+_\-]{10,32})\._AC_/); if (m) return normalizePid(m[1]);
    m = url.match(/\/([A-Za-z0-9+_\-]{10,32})_AC_/); if (m) return normalizePid(m[1]);
    m = url.match(/\/([A-Za-z0-9+_\-]{10,32})(?:_\d+x\d*)?\.(?:jpg|jpeg|png|webp)$/i);
    if (m) return normalizePid(m[1]);

    var base = (url.split('/').pop() || '').replace(/\.[^.]+$/, '');
    base = base.replace(/\._AC.*$/i, '').replace(/_AC.*$/i, '');
    return normalizePid(base);
  }

  function getImgSrc(li) {
    var img = li.querySelector('img');
    if (!img) return null;
    return img.getAttribute('data-src') || img.getAttribute('src') || null;
  }

  function filterGallery(urls) {
    var sid = getSectionId();
    if (!sid) return;

    var showPids = {};
    urls.forEach(function (url) {
      var pid = urlToPid(url);
      if (pid) showPids[pid] = true;
    });

    var allMainLis = document.querySelectorAll('#Slider-Gallery-' + sid + ' li[data-media-id]');
    var firstVisibleLi = null;
    allMainLis.forEach(function (li) {
      var pid = urlToPid(getImgSrc(li));
      var show = pid && showPids[pid];
      li.style.display = show ? '' : 'none';
      if (show && !firstVisibleLi) firstVisibleLi = li;
    });

    document.querySelectorAll('#Slider-Thumbnails-' + sid + ' li[data-target]').forEach(function (li) {
      var pid = urlToPid(getImgSrc(li));
      li.style.display = (pid && showPids[pid]) ? '' : 'none';
    });

    if (firstVisibleLi) {
      var mg = document.getElementById('MediaGallery-' + sid);
      if (mg && typeof mg.setActiveMedia === 'function') {
        try { mg.setActiveMedia(firstVisibleLi.dataset.mediaId, false); } catch (e) {}
      }
    }
  }

  function resolveVariantId(variantId) {
    var vid = normalizeVariantId(variantId);
    if (vid) return vid;

    var fromUrl = normalizeVariantId(getVariantFromUrl());
    if (fromUrl) return fromUrl;

    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (inp) {
      var iv = normalizeVariantId(inp.value);
      if (iv) return iv;
    }

    var mapVid = normalizeVariantId(lookupByCurrentOptions());
    if (mapVid) return mapVid;

    return '';
  }

  function onVariantChange(variantId) {
    var vid = resolveVariantId(variantId);
    if (!vid) {
      console.warn('[VGS] skip change: variant id unresolved');
      return;
    }
    if (vid === currentVarId) return;

    var data = getGalleryData();
    if (data) {
      var urls = data[vid];
      if (Array.isArray(urls) && urls.length > 0) {
        currentVarId = vid;
        filterGallery(urls);
      } else if (Array.isArray(urls) && urls.length === 0) {
        // 빈 배열은 전체 노출 대신 현재 상태 유지
        console.warn('[VGS] empty mapping keep current: ' + vid);
        currentVarId = vid;
      } else {
        // 미매핑 시 option-map 기반으로 한 번 더 보정
        var fb = normalizeVariantId(lookupByCurrentOptions());
        if (fb && fb !== vid && Array.isArray(data[fb]) && data[fb].length > 0) {
          currentVarId = fb;
          filterGallery(data[fb]);
          vid = fb;
        } else {
          console.warn('[VGS] not mapped keep current: ' + vid);
          currentVarId = vid;
        }
      }
    }

    updateAboutSection(currentVarId || vid);
    updateTitle(currentVarId || vid);
  }

  function getVariantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function checkUrlVariant() {
    var vid = normalizeVariantId(getVariantFromUrl());
    if (vid) onVariantChange(vid);
  }

  window.addEventListener('popstate', checkUrlVariant);

  var _origPushState = history.pushState.bind(history);
  history.pushState = function (state, title, url) {
    _origPushState(state, title, url);
    setTimeout(checkUrlVariant, 0);
  };

  var _origReplaceState = history.replaceState.bind(history);
  history.replaceState = function (state, title, url) {
    _origReplaceState(state, title, url);
    setTimeout(checkUrlVariant, 0);
  };

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant) {
      var urlVid = normalizeVariantId(getVariantFromUrl());
      onVariantChange(urlVid || normalizeVariantId(e.detail.variant.id));
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest('variant-selects, variant-radios, .product-form__input')) return;
    setTimeout(function () {
      onVariantChange('');
    }, 0);
  });

  function init() {
    var sid = getSectionId();
    if (!sid) return;

    var data = getGalleryData();
    if (!data) return;

    var variantId = resolveVariantId('');
    if (!variantId) {
      var keys = Object.keys(data);
      if (keys.length > 0) variantId = keys[0];
    }

    currentVarId = normalizeVariantId(variantId);
    if (currentVarId && Array.isArray(data[currentVarId]) && data[currentVarId].length > 0)
      filterGallery(data[currentVarId]);

    updateAboutSection(currentVarId);
    updateTitle(currentVarId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
